import { getRequest } from "./axios.js";
const getAllHospitals = async () => {
  const url = `/api/hospital/getAllHospitals`;
  const response = await getRequest(url);
  return response;
};
export default getAllHospitals;
